import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Details from '../Details/Details';

const SportsDetail = () => {
    const { explore } = useParams();
    const [ details, setDetails ] = useState([]);
    const url = (`https://www.thesportsdb.com/api/v1/json/1/lookupleague.php?id=${explore}`)
    useEffect(()=> {
        fetch(url)
        .then(res => res.json())
        .then(data => setDetails(data.leagues))
    }, [])

    return (
        <div>
            {
                details.map(detail => <Details detail={detail}></Details>)
            }
        </div>
    );
};

export default SportsDetail;